var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      !_vm.added
        ? _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("h2", [_vm._v("Add New Scoring Event")]),
                  _vm._v(" "),
                  _c("survey-run-selection", {
                    attrs: { "new-only": true },
                    on: { "update:surveyRun": _vm.saved }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.added
        ? _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _c("b-col", [
                _c("h2", [_vm._v("Scoring Event Saved")]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.surveyRun.programme.name) +
                    " - " +
                    _vm._s(_vm.surveyRun.customer.name) +
                    " " +
                    _vm._s(_vm.surveyRun.period) +
                    " " +
                    _vm._s(_vm.surveyRun.year) +
                    "\n    "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.added
        ? _c(
            "b-row",
            { staticClass: "pt-4", attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.added = false
                        }
                      }
                    },
                    [_vm._v("Add another")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.addSurveyData }
                    },
                    [_vm._v("Add Survey Data")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d82f601", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d82f601","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewScoringEvent.vue
// module id = null
// module chunks = 